export interface ShareMapToolOptions {
  hasCopyLinkButton?: boolean;
  hasShareMapButton?: boolean;
}
